import React from 'react';
import moment from 'moment';
import classnames from 'classnames';
import { Formik, Form, Field, connect as connectFormik } from 'formik';
import { Translate, withLocalize } from 'react-localize-redux';
import { Circles } from '../common/loadingComponent';
import { isNullOrUndefined } from '../../store/storeFunctions';
import { apiGet, getHostApi, apiPost, hasPermission } from '../../store/apiWrapper';
import Widget from '../common/widget';
import Message from '../common/message';
import BbDatePicker from '../common/datePicker';

import './settings.scss';

const ESS_MIN = 0;
const ESS_MAX = 100;

const SETTINGS_TYPES = {
    ESS: "ESS",
    ESSU: "ESSU",
    CEE: "CEE",
    CRE: "CRE"
};

class Settings extends React.Component {
    mounted = true;

    state = {
        error: false,
        essShareDefault: "",
        essShareDefaultUser: "",
        ceeMaxNumberOfCauses: "",
        ceeMaxNumberOfDetails: "",
        ceeCasesNotOlderThan: "",
        ceeMinMonetaryObligation: "",
        creMaxNumberOfCauses: "",
        creMaxNumberOfDetails: "",
        creCasesNotOlderThan: "",
        isLoading: true,
        isSaving: {
            [SETTINGS_TYPES.ESS]: false,
            [SETTINGS_TYPES.ESSU]: false,
            [SETTINGS_TYPES.CEE]: false,
            [SETTINGS_TYPES.CRE]: false
        }
    };

    componentDidMount() {
        apiGet(`${getHostApi()}/api/account/settings`, null,
            (s) => {
                if (!isNullOrUndefined(s) && !isNullOrUndefined(s.data)) {
                    this.setState({
                        essShareDefault: isNullOrUndefined(s.data.essShareDefault) ? "" : s.data.essShareDefault,
                        essShareDefaultUser: isNullOrUndefined(s.data.essShareDefaultUser) ? "" : s.data.essShareDefaultUser,
                        ceeMaxNumberOfCauses: isNullOrUndefined(s.data.ceeMaxNumberOfCauses) ? "" : s.data.ceeMaxNumberOfCauses,
                        ceeMaxNumberOfDetails: isNullOrUndefined(s.data.ceeMaxNumberOfDetails) ? "" : s.data.ceeMaxNumberOfDetails,
                        ceeCasesNotOlderThan: isNullOrUndefined(s.data.ceeCasesNotOlderThan) ? "" : moment(s.data.ceeCasesNotOlderThan).format("YYYY-MM-DD"),
                        ceeMinMonetaryObligation: isNullOrUndefined(s.data.ceeMinMonetaryObligation) ? "" : s.data.ceeMinMonetaryObligation,
                        creMaxNumberOfCauses: isNullOrUndefined(s.data.creMaxNumberOfCauses) ? "" : s.data.creMaxNumberOfCauses,
                        creMaxNumberOfDetails: isNullOrUndefined(s.data.creMaxNumberOfDetails) ? "" : s.data.creMaxNumberOfDetails,
                        creCasesNotOlderThan: isNullOrUndefined(s.data.creCasesNotOlderThan) ? "" : s.data.creCasesNotOlderThan
                    });
                }
            },
            (e) => console.error(e),
            () => this.setState({ isLoading: false })
        )
        this.mounted = true;
    }

    componentWillUnmount() {
        this.mounted = false;
    }

    render() {
        return (
            <div className="content-root settings-content-root">
                {this.state.error === true && <div style={{ marginTop: "1em" }}>
                    <Message type="error" message={this.props.translate("Common.Error.RequestFailed")} />
                </div>}
                {this.state.isLoading
                    ? <Circles />
                    : <>
                        {!hasPermission(null, "EconomicGroupSberbankMethodologyRole") && this.renderEssUserSettings()}
                        {hasPermission(null, "EconomicGroupManager") && !hasPermission(null, "EconomicGroupSberbankMethodologyRole") && this.renderEssSettings()}
                        {hasPermission(null, "CEEenhancedCzManage") && this.renderCeeSettings()}
                        {hasPermission(null, "CEEenhancedCzManage") && this.renderCreSettings()}
                    </>}
            </div>
        );
    }

    renderEssUserSettings = () => {
        return (
            <Widget className="widget" header="User.Settings.ESS.Title" initialExpanded={true}>
                <Formik
                    ref={(el) => this.essFormUser = el}
                    enableReinitialize={true}
                    validateOnChange={false}
                    validateOnBlur={false}
                    initialValues={{
                        essShareDefaultUser: this.state.essShareDefaultUser
                    }}
                    onSubmit={(values, { setSubmitting }) => {
                        setSubmitting(false);
                        this.onSubmit({ ...values, type: SETTINGS_TYPES.ESSU });
                    }}
                >
                    {({ values, setFieldValue }) => <Form>
                        <div className="settings-row">
                            <div><Translate id="User.Settings.ESS.MinimalOwnershipInterest" /></div>
                            <Field type="number" className="input settings-input" name="essShareDefaultUser" min={ESS_MIN} max={ESS_MAX}
                                onChange={e => this.onEssChanged(e.target.value, setFieldValue, true)}
                            />
                            <div>%</div>
                        </div>
                        <div><Translate id="User.Settings.ESS.Note" /></div>
                        <div className="settings-buttons">
                            <button type="submit"
                                disabled={this.state.isSaving[SETTINGS_TYPES.ESSU]}
                                className={classnames('bb-button gradient-1', {'is-square': localStorage.locales_button_style === 'square'})}
                            >
                                <Translate id="Common.Save" />
                            </button>
                        </div>
                    </Form>}
                </Formik>
            </Widget>
        );
    }

    renderEssSettings = () => {
        return (
            <Widget className="widget" header="User.Settings.ESS.Title.Customer" initialExpanded={true}>
                <Formik
                    ref={(el) => this.essForm = el}
                    enableReinitialize={true}
                    validateOnChange={false}
                    validateOnBlur={false}
                    initialValues={{
                        essShareDefault: this.state.essShareDefault
                    }}
                    onSubmit={(values, { setSubmitting }) => {
                        setSubmitting(false);
                        this.onSubmit({ ...values, type: SETTINGS_TYPES.ESS });
                    }}
                >
                    {({ values, setFieldValue }) => <Form>
                        <div className="settings-row">
                            <div><Translate id="User.Settings.ESS.MinimalOwnershipInterest" /></div>
                            <Field type="number" className="input settings-input" name="essShareDefault" min={ESS_MIN} max={ESS_MAX}
                                onChange={e => this.onEssChanged(e.target.value, setFieldValue, false)}
                            />
                            <div>%</div>
                        </div>
                        <div><Translate id="User.Settings.ESS.Note.Customer" /></div>
                        <div className="settings-buttons">
                            <button type="submit"
                                disabled={this.state.isSaving[SETTINGS_TYPES.ESS] || isNullOrUndefined(values.essShareDefault) || values.essShareDefault === ""}
                                className={classnames('bb-button gradient-1', { 'is-square': localStorage.locales_button_style === 'square' })}
                            >
                                <Translate id="Common.Save" />
                            </button>
                        </div>
                    </Form>}
                </Formik>
            </Widget>
        );
    }

    renderCeeSettings = () => {
        return (
            <Widget className="widget" header={`User.Settings.CEE.Title`} initialExpanded={true} headerOptions={{ renderInnerHtml: true }}>
                <Formik
                    ref={(el) => this.ceeForm = el}
                    enableReinitialize={true}
                    validateOnChange={false}
                    validateOnBlur={false}
                    initialValues={{
                        ceeMaxNumberOfCauses: this.state.ceeMaxNumberOfCauses,
                        ceeMaxNumberOfDetails: this.state.ceeMaxNumberOfDetails,
                        ceeCasesNotOlderThan: this.state.ceeCasesNotOlderThan,
                        ceeMinMonetaryObligation: this.state.ceeMinMonetaryObligation,
                    }}
                    onSubmit={(values, { setSubmitting }) => {
                        setSubmitting(false);
                        this.onSubmit({ ...values, type: SETTINGS_TYPES.CEE });
                    }}
                >
                    {({ values, setFieldValue }) => <Form>
                        <div className="settings-row">
                            <div><Translate id="User.Settings.CEE.DownloadMonetaryObligationFor1" /></div>
                            <Field type="number" className="input settings-input" name="ceeMaxNumberOfCauses" min="0" />
                            <div><Translate id="User.Settings.CEE.DownloadMonetaryObligationFor2" /></div>
                        </div>
                        <div>
                            <table className="table settings-executions-table">
                                <tbody>
                                    <tr>
                                        <td><Translate id="User.Settings.CEE.TotalNumberOfCases" /></td>
                                        <td><Field type="number" className="input" name="ceeMaxNumberOfDetails" min="0" /></td>
                                        <td></td>
                                    </tr>
                                    <tr>
                                        <td><Translate id="User.Settings.CEE.CaseIsNotOlderThan" /></td>
                                        <td>
                                            <BbDatePicker enableReinitialize
                                                placeholder=""
                                                value={values.ceeCasesNotOlderThan}
                                                afterDateChange={date => setFieldValue("ceeCasesNotOlderThan", this.getNewDate(date))}
                                                formDateFormat={"YYYY-MM-DD"}
                                            />
                                        </td>
                                        <td></td>
                                    </tr>
                                    <tr>
                                        <td><Translate id="User.Settings.CEE.AmountOfMonetaryObligation1" /></td>
                                        <td><Field type="number" className="input" name="ceeMinMonetaryObligation"  min="0" /></td>
                                        <td><Translate id="User.Settings.CEE.AmountOfMonetaryObligation2" /></td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div className="settings-buttons">
                            <button type="submit" disabled={this.state.isSaving[SETTINGS_TYPES.CEE]}
                                className={classnames('bb-button gradient-1', {'is-square': localStorage.locales_button_style === 'square'})}
                            >
                                <Translate id="Common.Save" />
                            </button>
                        </div>
                    </Form>}
                </Formik>
            </Widget>
        );
    }

    renderCreSettings = () => {
        return (
            <Widget className="widget" header={`User.Settings.CRE.Title`} initialExpanded={true} headerOptions={{ renderInnerHtml: true }}>
                <Formik
                    ref={(el) => this.creForm = el}
                    enableReinitialize={true}
                    validateOnChange={false}
                    validateOnBlur={false}
                    initialValues={{
                        creMaxNumberOfCauses: this.state.creMaxNumberOfCauses,
                        creMaxNumberOfDetails: this.state.creMaxNumberOfDetails,
                        creCasesNotOlderThan: this.state.creCasesNotOlderThan
                    }}
                    onSubmit={(values, { setSubmitting }) => {
                        setSubmitting(false);
                        this.onSubmit({ ...values, type: SETTINGS_TYPES.CRE });
                    }}
                >
                    {() => <Form>
                        <div className="settings-row">
                            <div><Translate id="User.Settings.CEE.DownloadMonetaryObligationFor1" /></div>
                            <Field type="number" className="input settings-input" name="creMaxNumberOfCauses"  min="0" />
                            <div><Translate id="User.Settings.CEE.DownloadMonetaryObligationFor2" /></div>
                        </div>
                        <div>
                            <table className="table settings-executions-table">
                                <tbody>
                                    <tr>
                                        <td><Translate id="User.Settings.CEE.TotalNumberOfCases" /></td>
                                        <td><Field type="number" className="input" name="creMaxNumberOfDetails"  min="0" /></td>
                                        <td></td>
                                    </tr>
                                    <tr>
                                        <td><Translate id="User.Settings.CEE.CaseIsNotOlderThan" /></td>
                                        <td><Field type="number" className="input" name="creCasesNotOlderThan"  min="0" /></td>
                                        <td></td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div className="settings-buttons">
                            <button type="submit" disabled={this.state.isSaving[SETTINGS_TYPES.CRE]}
                                className={classnames('bb-button gradient-1', {'is-square': localStorage.locales_button_style === 'square'})}
                            >
                                <Translate id="Common.Save" />
                            </button>
                        </div>
                    </Form>}
                </Formik>
            </Widget>
        )
    }

    getNewDate = (date) => {
        if (moment(date, "DD.MM.YYYY", true).isValid())
            return moment(date, "DD.MM.YYYY", true).format("YYYY-MM-DD");
        else if (moment(date, "YYYY-MM-DD", true))
            return date;
        else
            return "";
    }

    onEssChanged = (value, setFieldValue, user) => {
        let parsed = parseInt(value);
        if (isNullOrUndefined(parsed) || isNaN(parsed))
            parsed = "";
        if (parsed < ESS_MIN)
            parsed = ESS_MIN;
        if (parsed > ESS_MAX)
            parsed = ESS_MAX;
        if (user)
            setFieldValue("essShareDefaultUser", parsed);
        else
            setFieldValue("essShareDefault", parsed);
    }

    onSubmit = (values) => {
        this.setState({ isSaving: { ...this.state.isSaving, [values.type]: true } });
        apiPost(`${getHostApi()}/api/account/settings/update`, null, this.createFormData(values),
            (s) => this.setState({ isSaving: { ...this.state.isSaving, [values.type]: false }, error: s.data !== true }),
            (_) => console.error({ isSaving: { ...this.state.isSaving, [values.type]: false }, error: true }),
        );
    }

    createFormData = (values) => {
        if (isNullOrUndefined(values))
            return {};

        switch (values.type) {
            case SETTINGS_TYPES.ESS: return {
                type: values.type,
                essShareDefault: isNullOrUndefined(values.essShareDefault) || values.essShareDefault === "" ? null : values.essShareDefault
            };
            case SETTINGS_TYPES.ESSU: return {
                type: values.type,
                essShareDefaultUser: isNullOrUndefined(values.essShareDefaultUser) || values.essShareDefaultUser === "" ? null : values.essShareDefaultUser
            };
            case SETTINGS_TYPES.CEE: return {
                type: values.type,
                ceeMaxNumberOfCauses: isNullOrUndefined(values.ceeMaxNumberOfCauses) || values.ceeMaxNumberOfCauses === "" ? null : values.ceeMaxNumberOfCauses,
                ceeMaxNumberOfDetails: isNullOrUndefined(values.ceeMaxNumberOfDetails) || values.ceeMaxNumberOfDetails === "" ? null : values.ceeMaxNumberOfDetails,
                ceeCasesNotOlderThan: isNullOrUndefined(values.ceeCasesNotOlderThan) || values.ceeCasesNotOlderThan === "" ? null : values.ceeCasesNotOlderThan,
                ceeMinMonetaryObligation: isNullOrUndefined(values.ceeMinMonetaryObligation) || values.ceeMinMonetaryObligation === "" ? null : values.ceeMinMonetaryObligation
            };
            case SETTINGS_TYPES.CRE: return {
                type: values.type,
                creMaxNumberOfCauses: isNullOrUndefined(values.creMaxNumberOfCauses) || values.creMaxNumberOfCauses === "" ? null : values.creMaxNumberOfCauses,
                creMaxNumberOfDetails: isNullOrUndefined(values.creMaxNumberOfDetails) || values.creMaxNumberOfDetails === "" ? null : values.creMaxNumberOfDetails,
                creCasesNotOlderThan: isNullOrUndefined(values.creCasesNotOlderThan) || values.creCasesNotOlderThan === "" ? null : values.creCasesNotOlderThan
            };
            default: return {};
        };
    }
}

export default withLocalize(connectFormik(Settings));